import type { FreelancerAvailabilityLocales } from '../types';

const freelancerAvailabilityLocales: FreelancerAvailabilityLocales = {
  availabilitySaved: 'Beschikbaarheid opgeslagen!',
  endDateIsRequiredWhenRepeating: 'Eind datum is verplicht bij herhalen.',
  enterBothStartAndEndTimeOrLeaveBothBlank:
    'Voer zowel start als eind tijd in, of laat beide leeg.',

  LeaveStartAndEndTimeBlankIfYouAreAvailableAllday:
    'Laat start- en eindtijd leeg als je de hele dag beschikbaar bent',
  perMonth: 'Per Maand',
  perWeek: 'Per Week',
  repeatDateMustBeLessThan6Months:
    'Herhalingsdatum moet minder dan 6 maanden zijn.',
  startDateMustBeLessThanEndDate: 'Startdatum moet kleiner zijn dan einddatum',
  toRepeat: 'Herhalen',
  UseThisDailyAvailabilityForALongerPeriodOfTime:
    'Gebruik deze dagelijkse beschikbaarheid voor langere tijd',
};

export default freelancerAvailabilityLocales;
